export function XeroSupportFindContactByIdCtrl ($scope, $uibModalInstance, workshopAPI, contact) {

  $scope.contact = contact ? contact : {};

}